import React from "react";
import { motion } from "framer-motion";
import { Box, Typography } from "@mui/material";
import { CustomMarkdown } from "../custom-markdown/custom-markdown";
import { AvatarWithCircle } from "../user-menu-trigger/user-avatar/avatar-with-circle";
import { useStatisticsStore } from "../../stores/statisticsStore";
import useUserStore from "../../stores/userStore";
import { useAppStore } from "../../stores/appStore";
import { PioneerClubItem } from "../../types/statistics";
import { parsePioneerText } from "./parse-pioneer-text";
import {
  avatarWrapperStyle,
  containerStyle,
  getCardStyle,
  getCornerRibbonStyle,
  scrollContainerStyle,
  textBlockStyle,
  titleStyle,
} from "./styles";

export const PioneerLounge: React.FC = () => {
  const { pioneersClub } = useStatisticsStore();
  const { user } = useUserStore();
  const { userAvatar } = useAppStore();

  if (!pioneersClub || pioneersClub.length === 0) {
    return null;
  }

  const sortedByScore = [...pioneersClub].sort((a, b) => {
    const parseA = parsePioneerText(a.text);
    const parseB = parsePioneerText(b.text);
    const scoreA = parseFloat(parseA.totalScore) || 0;
    const scoreB = parseFloat(parseB.totalScore) || 0;
    return scoreB - scoreA;
  });

  const avatarMinScore = 0;
  const avatarMaxScore = 5;

  return (
    <Box sx={containerStyle}>
      <Typography sx={titleStyle}>🏅Pioneers Lounge</Typography>
      <Box sx={scrollContainerStyle}>
        {sortedByScore.map((item: PioneerClubItem, index: number) => {
          const isCurrentUser = item.user_id === user?.id;
          const parsed = parsePioneerText(item.text);
          const score = parseFloat(parsed.totalScore) || 0;

          return (
            <Box key={item.user_id} sx={getCardStyle()}>
              <Box
                component={motion.div}
                initial={{ y: "-100%", opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{
                  duration: 0.65,
                  ease: [0.25, 0.46, 0.45, 0.94],
                  delay: index * 0.06,
                }}
                sx={getCornerRibbonStyle()}
              />
              <Box sx={avatarWrapperStyle}>
                <AvatarWithCircle
                  size="40px"
                  name={item.name}
                  img={isCurrentUser ? userAvatar : (item.avatar ?? "")}
                  userId={item.user_id}
                  hideText={true}
                  showOnlyLevel={true}
                  useGlobalTrigger={false}
                  isCurrentUser={isCurrentUser}
                  score={score}
                  minScore={avatarMinScore}
                  maxScore={avatarMaxScore}
                  place={index + 1}
                  totalParticipants={sortedByScore.length}
                />
              </Box>
              <Box sx={textBlockStyle}>
                <CustomMarkdown>{item.text}</CustomMarkdown>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
